<template>
    <!--begin::Card-->
    <div class="row">
        <div class="col-md-6"> 
            <div class="card card-custom">
                <!--begin::Header-->
                <div class="card-header py-3">
                    <div class="card-title align-items-start flex-column">
                        <h3 class="card-label font-weight-bolder text-dark">
                            Profil Bilgilerim
                        </h3>
                        <span class="text-muted font-weight-bold font-size-sm mt-1"
                            >Profil bilgilerinizi güncelleyin</span
                        >
                    </div>
                    <div class="card-toolbar">
                        <button
                            type="reset"
                            class="btn btn-success mr-2"
                            @click="save()"
                            ref="kt_save_changes"
                        >
                            Kaydet
                        </button>
                        <button
                            type="reset"
                            class="btn btn-primary mr-2"
                            @click="save_and_go_to_my_passoligs()"
                            ref="kt_save_changes_and_go_to_my_passoligs"
                        >
                            Kaydet ve Passolig Bilgilerime Git
                        </button>
                        <button
                            type="reset"
                            class="btn btn-secondary"
                            @click="cancel()"
                        >
                            İptal
                        </button>
                    </div>
                </div>
                <!--end::Header-->
                <!--begin::Form-->
                
                
                <form class="form">
                    <!--begin::Body-->
                    <div class="card-body">
                        <div class="row">
                            <label class="col-xl-3"></label>
                            <div class="col-lg-9 col-xl-6">
                                <h5 class="font-weight-bold mb-6">Profil Bilgilerim</h5>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-xl-3 col-lg-3 col-form-label text-right">
                                Fotoğraf *
                            </label>
                            <div class="col-lg-9 col-xl-6 d-flex flex-column flex-md-row align-items-center">
                                <div class="mr-md-5 mb-3 mb-md-0">
                                    <div class="image-input image-input-outline mr-3" id="kt_profile_avatar">
                                        <div class="image-input-wrapper" :style="{ backgroundImage: `url(${photo})` }"></div>
                                        <label
                                            class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                            data-action="change"
                                            data-toggle="tooltip"
                                            title=""
                                            data-original-title="Change avatar"
                                        >
                                            <i class="fa fa-pen icon-sm text-muted"></i>
                                            <input
                                                type="file"
                                                name="profile_avatar"
                                                accept=".png, .jpg, .jpeg"
                                                @change="onFileChange($event)"
                                            />
                                            <input type="hidden" name="profile_avatar_remove" />
                                            <input ref="id" type="hidden" v-model="currentUserPersonalInfo.user.id" />
                                        </label>
                                        <span
                                            class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                            data-action="cancel"
                                            data-toggle="tooltip"
                                            title="Cancel avatar"
                                        >
                                            <i class="ki ki-bold-close icon-xs text-muted"></i>
                                        </span>
                                        <span
                                            class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                            data-action="remove"
                                            data-toggle="tooltip"
                                            title="Remove avatar"
                                            @click="current_photo = null"
                                        >
                                            <i class="ki ki-bold-close icon-xs text-muted"></i>
                                        </span>
                                    </div>
                                </div>
                                <!-- Illustration Image -->
                                <div class="image-input image-input-outline mr-9" >
                                    <div class="image-input-wrapper" :style="{ backgroundImage: `url(${current_illustrated_photo})` }"></div>
                                </div>
                            </div>
                            
                            <span class="form-text text-muted">
                                İzin verilen resim türleri: png, jpg, jpeg.
                            </span>
                            <span class="form-text text-muted">
                                Profil resminizin örnekteki gibi olduğundan emin olunuz.
                            </span>
                        </div>

                        
                        <div class="form-group row">
                            <label class="col-xl-3 col-lg-3 col-form-label text-right"
                                >İsim Soyisim *</label
                            >
                            <div class="col-lg-9 col-xl-6">
                                <input
                                    ref="name"
                                    class="form-control form-control-lg form-control-solid"
                                    type="text"
                                    v-model="currentUserPersonalInfo.user.name"
                                    disabled
                                />
                                <div v-if="errors.name" :errors="errors">
                                    <p v-for="error in errors.name" class="mr-1 text-danger" :key="error.name">{{ error }}</p>
                                </div>
                                
                            </div>
                        </div>
                        
                        
                    
                        <div class="form-group row">
                            <label class="col-xl-3 col-lg-3 col-form-label text-right"
                                >Email *</label
                            >
                            <div class="col-lg-9 col-xl-6">
                                <div
                                    class="input-group input-group-lg input-group-solid"
                                >
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class="la la-at"></i>
                                        </span>
                                    </div>
                                    <input
                                        ref="email"
                                        type="text"
                                        class="form-control form-control-lg form-control-solid"
                                        placeholder="Email"
                                        v-model="currentUserPersonalInfo.user.email"
                                        readonly
                                    />
                                </div>
                            </div>
                            <div v-if="errors.email" :errors="errors">
                                <p v-for="error in errors.email" class="mr-1 text-danger" :key="error.email">{{ error }}</p>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-xl-3 col-lg-3 col-form-label text-right"
                                >Üye No</label
                            >
                            <div class="col-lg-9 col-xl-6">
                                <input
                                    class="form-control form-control-lg form-control-solid"
                                    type="text"
                                    v-model="currentUserPersonalInfo.user.member_no"
                                    readonly
                                    disabled
                                />
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-xl-3 col-lg-3 col-form-label text-right"
                                >Doğum Tarihi *</label
                            >
                            <div class="col-lg-9 col-xl-6">
                                <div
                                    class="input-group input-group-lg input-group-solid"
                                >
                                    <input
                                        ref="date_of_birth"
                                        class="form-control form-control-lg form-control-solid"
                                        type="date"
                                        v-model="currentUserPersonalInfo.user.date_of_birth"
                                    />
                                </div>
                            </div>
                            <div v-if="errors.date_of_birth" :errors="errors">
                                <p v-for="error in errors.date_of_birth" class="mr-1 text-danger" :key="error.date_of_birth">{{ error }}</p>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-xl-3 col-lg-3 col-form-label text-right"
                                >Doğum Yeri *</label
                            >
                            <div class="col-lg-9 col-xl-6">
                                <input
                                    ref="birth_place"
                                    class="form-control form-control-lg form-control-solid"
                                    type="text"
                                    v-model="currentUserPersonalInfo.user.birth_place"
                                />
                            </div>
                            <div v-if="errors.birth_place" :errors="errors">
                                <p v-for="error in errors.birth_place" class="mr-1 text-danger" :key="error.birth_place">{{ error }}</p>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-xl-3 col-lg-3 col-form-label text-right"
                                >İkamet Ettiği Bölge *</label
                            >
                            <div class="col-lg-9 col-xl-6">
                                <select 
                                    class="form-control form-control-lg form-control-solid"
                                    ref="region"
                                    v-model="currentUserPersonalInfo.user.region"
                                >
                                    <option value="" selected>İkamet Ettiği Bölge</option>  
                                    <option v-for="region in regions" :value="region" :key="region">{{ region }}</option>
                                </select>
                            </div>
                            <div v-if="errors.region" :errors="errors">
                                <p v-for="error in errors.region" class="mr-1 text-danger" :key="error.region">{{ error }}</p>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-xl-3 col-lg-3 col-form-label text-right"
                                >Meslek</label
                            >
                            <div class="col-lg-9 col-xl-6">
                                <input
                                    ref="job"
                                    class="form-control form-control-lg form-control-solid"
                                    type="text"
                                    v-model="currentUserPersonalInfo.user.job"
                                />
                            </div>
                            <div v-if="errors.job" :errors="errors">
                                <p v-for="error in errors.job" class="mr-1 text-danger" :key="error.job">{{ error }}</p>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-xl-3 col-lg-3 col-form-label text-right"
                                >Kan Grubu</label
                            >
                            <div class="col-lg-9 col-xl-6">
                                <select 
                                    class="form-control form-control-lg form-control-solid"
                                    ref="blood_group"
                                    v-model="currentUserPersonalInfo.user.blood_group"
                                >
                                    <option value="" selected>Kan Grubu</option>  
                                    <option v-for="blood_group in blood_groups" :value="blood_group" :key="blood_group">{{ blood_group }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-xl-3 col-lg-3 col-form-label text-right"
                                >Cep Telefonu *</label
                            >
                            <div class="col-lg-9 col-xl-6">
                                <input
                                    ref="mobile_phone"
                                    class="form-control form-control-lg form-control-solid"
                                    type="text"
                                    v-model="currentUserPersonalInfo.user.mobile_phone"
                                />
                            </div>
                        </div>
                        
                        <div class="form-group row">
                            <label class="col-xl-3 col-lg-3 col-form-label text-right"
                                >Ev Telefonu</label
                            >
                            <div class="col-lg-9 col-xl-6">
                                <input
                                    ref="home_phone"
                                    class="form-control form-control-lg form-control-solid"
                                    type="text"
                                    v-model="currentUserPersonalInfo.user.home_phone"
                                />
                            </div>
                        </div>
                    
                        
                        <div class="form-group row">
                            <label class="col-xl-3 col-lg-3 col-form-label text-right"
                                >Adres</label
                            >
                            <div class="col-lg-9 col-xl-6">
                                <textarea
                                    ref="address"
                                    class="form-control form-control-lg form-control-solid"
                                    type="text"
                                    v-model="currentUserPersonalInfo.user.address"
                                >
                                </textarea>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-xl-3 col-lg-3 col-form-label text-right"
                                >Üyelik Statüsü</label
                            >
                            <div class="col-lg-9 col-xl-6">
                                <b-badge class="mr-1" :variant="getClass(currentUserPersonalInfo.user.status)" v-if="currentUserPersonalInfo.user.status">
                                    <h4>{{ currentUserPersonalInfo.user.status }}</h4>
                                </b-badge>
                                
                            </div>
                        </div>
                    </div>
                    <!--end::Body-->
                </form>
                    
                <div class="card-title align-items-start flex-column">
                    
                </div>
                <div class="card-footer d-flex justify-content-end">
                    <button
                        type="reset"
                        class="btn btn-success mr-2"
                        @click="save()"
                        ref="kt_save_changes"
                    >
                        Kaydet
                    </button>
                    <button
                        type="reset"
                        class="btn btn-primary mr-2"
                        @click="save_and_go_to_my_passoligs()"
                        ref="kt_save_changes_and_go_to_my_passoligs"
                    >
                        Kaydet ve Passolig Bilgilerime Git
                    </button>
                    <button
                        type="reset"
                        class="btn btn-secondary"
                        @click="cancel()"
                    >
                        İptal
                    </button>
                </div>
                <!--end::Form-->
            </div>
        </div>
        <div class="col-md-6"> 
            <div class="card card-custom">
                <!--begin::Header-->
                <div class="card-header py-3">
                    <div class="card-title align-items-start flex-column">
                        <h3 class="card-label font-weight-bolder text-dark">
                            Yardım <i class="fas fa-exclamation-circle warning"></i>
                        </h3>
                        <span class="text-muted font-weight-bold font-size-sm mt-1"
                            >Sayfada izleyeceğiniz yol ile ilgili detaylı bilgiler</span
                        >
                    </div>
                    
                </div>
                <!--end::Header-->
                <!--begin::Form-->
                
                <form class="form">
                    <!--begin::Body-->
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12 col-xl-12">
                                <ul>
                                    <li>Borcunuz olmadığından emin olun. Borcunuz varsa herhangi bir bilet talebinde bulunamayacaksınız. Borcunuzu <b-button variant="outline-danger" @click="goToMyMembership">buradan</b-button> kontrol edebilirsiniz.</li>
                                    <li>Şu an üyelik durumunuz: <b-badge>{{ currentUserPersonalInfo.user.status }}</b-badge></li>
                                    <li>Üyelik durumunuz <b-badge>Aktif</b-badge> değilse lütfen sistem yöneticisi ile görüşünüz. Telefon: 0533 838 87 87</li>
                                    <li>Bu sayfadan, yani profil bilgilerinizden fotoğrafınızı yüklediğinizden emin olun. Fotoğrafınız yoksa bilet talebinde bulunamayacaksınız.</li>
                                    <li>Geçerli bir passolig üye kartı ekleyiniz. Passolig kartını <b-button variant="outline-danger" @click="goToMyPassoligs">buradan</b-button> tanımlayabilirsiniz.</li>
                                    <li>Hem kendiniz hem de aileniz için passolig üye kartları tanımlayabilirsiniz. Tanımlanan passolig kartları sistem yöneticisi tarafından onaylanacaktır. Daha sonra onaylanmış passolig kartları ile bilet tanımı yapabileceksiniz.</li>
                                    <li>Kendiniz ve aileniz için veya başka bir yakınınız için de bilet talep edebilirsiniz. Başka bir yakınınız yaptığınız bilet talepleri, ilgili kişi tarafından 15dk içinde onaylanması ve rezervasyonu kabul etmesi gerekir. Aksi taktirde rezervasyon geçersiz olacaktır.</li>
                                </ul>
                                
                            </div>
                        </div>
                       
                    </div>
                    <!--end::Body-->
                </form>
                    
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { UPDATE_PERSONAL_INFO } from "@/core/services/store/profile.module";
import { GET_PERSONAL_INFO } from "@/core/services/store/profile.module";
import constants from '@/core/constants/index';

export default {
    name: "MyProfile",
    data() {
        return {
            default_photo: "media/users/blank.png",
            illustrated_photo: "media/users/illustrated_photo.jpg",
            current_photo: null,
            regions: constants.REGIONS,
            blood_groups: constants.BLOOD_GROUPS,
        };
    },
    created() {
        this.getPersonalInfo();

    },
    mounted() {
        this.current_photo = this.currentUserPersonalInfo.user.photo;
    },
    methods: {
        save() {
            var id = this.$refs.id.value;
            var name = this.$refs.name.value;
            var email = this.$refs.email.value;
            var photo = this.photo;
            var date_of_birth = this.$refs.date_of_birth.value;
            var birth_place = this.$refs.birth_place.value;
            var region = this.$refs.region.value;
            var job = this.$refs.job.value;
            var blood_group = this.$refs.blood_group.value;
            var mobile_phone = this.$refs.mobile_phone.value;
            var home_phone = this.$refs.home_phone.value;
            var address = this.$refs.address.value;
            
            // set spinner to submit button
            const submitButton = this.$refs["kt_save_changes"];
            submitButton.classList.add(
                "spinner",
                "spinner-light",
                "spinner-right"
            );

            // dummy delay
            setTimeout(() => {
                // send update request
                this.$store.dispatch(UPDATE_PERSONAL_INFO, {
                    id,
                    name,
                    email,
                    photo,
                    date_of_birth,
                    birth_place,
                    region,
                    job,
                    blood_group,
                    mobile_phone,
                    home_phone,
                    address
                })
                .then(() => {
                    this.getPersonalInfo();
                });

                submitButton.classList.remove(
                    "spinner",
                    "spinner-light",
                    "spinner-right"
                );
            }, 2000);

            //this.getPersonalInfo();
        },

        save_and_go_to_my_passoligs() {
            var id = this.$refs.id.value;
            var name = this.$refs.name.value;
            var email = this.$refs.email.value;
            var photo = this.photo;
            var date_of_birth = this.$refs.date_of_birth.value;
            var birth_place = this.$refs.birth_place.value;
            var region = this.$refs.region.value;
            var job = this.$refs.job.value;
            var blood_group = this.$refs.blood_group.value;
            var mobile_phone = this.$refs.mobile_phone.value;
            var home_phone = this.$refs.home_phone.value;
            var address = this.$refs.address.value;
            
            // set spinner to submit button
            const submitButton = this.$refs["kt_save_changes_and_go_to_my_passoligs"];
            submitButton.classList.add(
                "spinner",
                "spinner-light",
                "spinner-right"
            );

            // dummy delay
            setTimeout(() => {
                // send update request
                this.$store.dispatch(UPDATE_PERSONAL_INFO, {
                    id,
                    name,
                    email,
                    photo,
                    date_of_birth,
                    birth_place,
                    region,
                    job,
                    blood_group,
                    mobile_phone,
                    home_phone,
                    address
                })
                .then(() => {
                    this.getPersonalInfo();
                    this.$router.push({ name: "my-passoligs" });
                });

                submitButton.classList.remove(
                    "spinner",
                    "spinner-light",
                    "spinner-right"
                );
            }, 2000);

            //this.getPersonalInfo();
        },

        getPersonalInfo() {
            this.$store.dispatch(GET_PERSONAL_INFO)
        },

        getClass(status) {
            if (status == "Ödeme Yapıldı Onay Bekliyor") return 'warning'
            if (status == "Aktif") return 'success'
            if (status == "İhraç") return 'danger'
            if (status == "İstifa") return 'warning'
            if (status == "Vefat") return 'secondary'
        },

        cancel() {
            this.$refs.id.value = this.currentUserPersonalInfo.user.id;
            this.$refs.name.value = this.currentUserPersonalInfo.user.name;
            this.$refs.email.value = this.currentUserPersonalInfo.user.email;
            this.current_photo = this.currentUserPersonalInfo.user.photo;
            this.$refs.date_of_birth.value = this.currentUserPersonalInfo.user.date_of_birth;
            this.$refs.birth_place.value = this.currentUserPersonalInfo.user.birth_place;
            this.$refs.region.value = this.currentUserPersonalInfo.user.region;
            this.$refs.job.value = this.currentUserPersonalInfo.user.job;
            this.$refs.blood_group.value = this.currentUserPersonalInfo.user.blood_group;
            this.$refs.mobile_phone.value = this.currentUserPersonalInfo.user.mobile_phone;
            this.$refs.home_phone.value = this.currentUserPersonalInfo.user.home_phone;
            this.$refs.address.value = this.currentUserPersonalInfo.user.address;
        },
        onFileChange(e) {
            const file = e.target.files[0];
            
            if (typeof FileReader === "function") {
                const reader = new FileReader();

                reader.onload = event => {
                    this.current_photo = event.target.result;
                };

                reader.readAsDataURL(file);
            } else {
                alert("Sorry, FileReader API not supported");
            }
        },

        goToMyMembership(){
            this.$router.push({ name: "my-membership" });
        },

        goToMyPassoligs(){
            this.$router.push({ name: "my-passoligs" });
        }
    },
    watch: {
        currentUserPersonalInfo: {
            immediate: true, 
            handler(newValue) {
                this.current_photo = newValue.user.photo;
            }
        }
    },
    computed: {
        ...mapState({
            errors: state => state.profile.errors
        }),
        ...mapGetters(["currentUserPersonalInfo"]),
        photo() {
            return this.current_photo == null
                ? this.default_photo
                : this.current_photo;
        }, 
        current_illustrated_photo() {
            return this.illustrated_photo;
        }
    }
};
</script>
<style>
.warning {
    color: red;
    font-size: 16px;
}
</style>
